import { IPartnerAppSettings } from '../interface/IPartnerAppSettings';

export const sit: IPartnerAppSettings = {
  cdnBaseUrl: '',
  serviceEndPoints: [
    {
      clientId: 'c8955af6-b4a7-4e96-86b7-ad0930c25fa7',
      serviceEndPoint: 'https://dmsitafd.azurefd.net/'
    },
    {
      clientId: '99b7fa0a-a125-4f7a-abea-efb429bb8972',
      serviceEndPoint: 'https://oneprofileuatapipack.azurefd.net/api/v1/'
    },
    {
      clientId: '99b7fa0a-a125-4f7a-abea-efb429bb8972',
      serviceEndPoint: 'https://oneprofileuatapipack.azurefd.net/api/v2.0/'
    },
    {
      clientId: 'c1df0735-5f8f-4429-9977-80e732362bdd',
      serviceEndPoint: 'https://fd-rmxcsvc-sit-dch6dacwbedegta6.b02.azurefd.net/'
    },
    {
      clientId: '00000003-0000-0000-c000-000000000000',
      serviceEndPoint: 'https://graph.microsoft.com/'
    },
    {
      clientId: 'f77695f8-032a-43b9-9263-418c7efa2c56',
      serviceEndPoint: 'https://professionalservicesint.microsoft.com/csp-api/'
    },
    {
      clientId: '5281bfb5-a855-4e14-b6e0-2e6a1d2ab82d',
      serviceEndPoint: 'https://tubfactory-api-dev-cucecwcgf5f4ggh4.westus-01.azurewebsites.net/'
    }
  ],
  ReactDmAppConfiguration: {
    cspSubscriptionKey: '92af6c717f5b4f2c9a41db17e17cc947',
    dmServiceBaseUri: 'https://dmsitafd.azurefd.net/',
    cspBaseUrl: 'https://professionalservicesint.microsoft.com/csp-api/',
    oneProfileBaseUrl: 'https://oneprofileuatapipack.azurefd.net/',
    oneProfileGraphQlBaseUrl: 'https://preprod.apis.profileskills.microsoft.com/',
    oneProfileGraphQLPageSize: 1000,
    esxpBaseUrl: 'https://servicesint.azurewebsites.net/#/',
    rmexBaseUrl: 'https://fd-rmxcsvc-sit-dch6dacwbedegta6.b02.azurefd.net/',
    rmexCustomersBaseUrl: 'https://professionalservicesint.microsoft.com/rm-customers-api/api/v1.0/',
    rmexCustomersSubscriptionKey: 'da0ed7b1237d4183aa5884bbd02782ad',
    msxOpportunityUrl: 'https://msxuat.crm.dynamics.com/main.aspx?etn=opportunity&pagetype=entityrecord&id=%s',
    roleIds: '28,161,165,193',
    managerRoleIds: '162,195,210,59',
    graphBaseApi: 'https://graph.microsoft.com/v1.0/',
    tubServiceBaseUri: 'https://tubfactory-api-dev-cucecwcgf5f4ggh4.westus-01.azurewebsites.net/',
    ocvFeedbackIsProduction: false
  }
};
